import React, { FC } from "react"
import L10n from "lib/carrot-l10n"
import { useDispatch, useSelector } from "react-redux"
import { FormProvider, useForm } from "react-hook-form"
import { Spacer } from "../../atoms/Atoms"
import { updateUserInfo } from "../../../../actions/userActions"
import { getMemberHasLegalPartner } from "../../../../reducers/userInfo"
import {
  BenefitEnrollmentFlowModalBackButton,
  BenefitEnrollmentModalContinueButton,
  BenefitEnrollmentModalFormSelect
} from "./BenefitEnrollmentFlowModal"
import { Steps } from "./Workflow/Steps"
import useSubmitWithErrorCatch from "./hooks/useSubmitWithErrorCatch"
import { useProgressTracker } from "../ProgressTracker"
import { useStateMachine } from "../../../context/stateMachine/StateMachineContext"
import { H2 } from "@carrotfertility/carotene"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const FieldName = "memberHasLegalPartnerValue"
const ViewName = Steps.MEMBER_HAS_LEGAL_PARTNER

const MemberDoYouHavePartnerView: FC = () => {
  const { setProgress } = useProgressTracker()
  const dispatch = useDispatch()
  const formMethods = useForm()
  const memberHasLegalPartner = useSelector(getMemberHasLegalPartner)
  const { setNextStep } = useStateMachine(ViewName, memberHasLegalPartner)
  const { onSubmit } = useSubmitWithErrorCatch(async (args) => {
    const val = args[FieldName].id
    await dispatch(updateUserInfo({ memberHasLegalPartner: val }))
    setNextStep(ViewName, val)
  })

  setProgress(1, "YOUR INSURANCE COVERAGE")

  const { handleSubmit } = formMethods

  return (
    <FormProvider {...formMethods}>
      <BenefitEnrollmentFlowModalBackButton />

      <Spacer height={3} />
      <H2 variant="dark">{l`Do you have a partner?`}</H2>
      <Spacer height={2} />
      <BenefitEnrollmentModalFormSelect
        name={FieldName}
        defaultValue={memberHasLegalPartner}
        options={[
          { label: l(`Yes`), id: "true" },
          { label: l(`No`), id: "false" }
        ]}
      />
      <Spacer height={4} />
      <BenefitEnrollmentModalContinueButton onClick={handleSubmit(onSubmit)} />
    </FormProvider>
  )
}

export { MemberDoYouHavePartnerView }
